import script from "./MenuSuperiorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSuperiorComponent.vue?vue&type=script&setup=true&lang=js"

import "./MenuSuperiorComponent.vue?vue&type=style&index=0&id=78a921cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a921cc"]])

export default __exports__